/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Min_StockInputs */

const vi_packaging_material_min_stock = /** @type {(inputs: Packaging_Material_Min_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn tối thiểu`)
};

/**

* @param {Packaging_Material_Min_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_min_stock = /** @type {((inputs?: Packaging_Material_Min_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Min_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_min_stock(inputs)
});